import { Snackbar } from '@mui/material';
import { useErrorStore } from '../stores/errorStore';

/**
 * Simple notification component that maintains existing Snackbar UI
 * Replaces repetitive Snackbar patterns across components
 */
export function NotificationManager() {
  const { toasts, removeToast } = useErrorStore();

  // Show only the first toast to maintain single Snackbar behavior
  const currentToast = toasts[0];

  if (!currentToast) {
    return null;
  }

  const handleClose = () => {
    removeToast(currentToast.id);
  };

  return (
    <Snackbar
      open
      autoHideDuration={currentToast.duration || 3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      message={currentToast.message}
    />
  );
}

export default NotificationManager;
